/* AERES — interactions */
document.addEventListener('DOMContentLoaded', function () {

  /* Carousel arrows */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var step = function () {
      var card = track.firstElementChild;
      return card ? card.getBoundingClientRect().width + 24 : 280;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* Accordions (product details) */
  document.querySelectorAll('[data-accordion] > [data-acc-head]').forEach(function (head) {
    head.addEventListener('click', function () {
      var item = head.parentElement;
      item.classList.toggle('is-open');
    });
  });

  /* Rotating announcement bar */
  document.querySelectorAll('[data-announce]').forEach(function (bar) {
    var items = bar.querySelectorAll('[data-announce-item]');
    if (items.length < 2) return;
    var i = 0;
    items[0].classList.add('is-active');
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });

  /* Sticky header shadow on scroll */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Product size selector + qty */
  document.querySelectorAll('[data-size]').forEach(function (group) {
    group.querySelectorAll('[data-size-opt]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        group.querySelectorAll('[data-size-opt]').forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
      });
    });
  });
  document.querySelectorAll('[data-qty]').forEach(function (group) {
    var input = group.querySelector('input');
    group.querySelector('[data-minus]').addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    group.querySelector('[data-plus]').addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });
});
